import angular from "angular";
import notifierService from "./notifier.service";
import authService from "./auth.service";
import userCanDirective from "./user-can.directive";
import dataService from "./data.service";

angular.module('core', [notifierService, authService, userCanDirective, dataService]);

export default 'core';


// WEBPACK FOOTER //
// ./resources/assets/modules/core/core.module.js